import {
  Card,
  CardInteraction,
  IconContainer,
  Link,
} from '@utilitywarehouse/hearth-react';
import { AddMediumIcon } from '@utilitywarehouse/hearth-react-icons';

interface AddSimTileProps {
  onClick: () => void;
}

const AddSimTile = ({ onClick }: AddSimTileProps) => (
  <Card
    variant="subtle"
    colorScheme="neutralStrong"
    data-testid="mobile-sim-add"
    spacing="lg"
    alignItems="center"
    justifyContent="center"
    direction="column"
    flex="1"
  >
    <IconContainer size="md" variant="subtle" colorScheme="mobile">
      <AddMediumIcon />
    </IconContainer>
    <CardInteraction asChild>
      <Link asChild>
        <button type="button" onClick={onClick}>
          Add a SIM
        </button>
      </Link>
    </CardInteraction>
  </Card>
);

export { AddSimTile };
